export enum WebPushSubscriptionStatus {
    NotSubscribed = 0,
    Subscribed = 1,
    Unsupported = 2
}
